import { DataStatusSection } from '../components/data-status-section';
import { PipelineStatusSection } from '../components/pipeline-status-section';
import { PlatformHealthSection } from '../components/platform-health-section';

const EtlDashboardTab = () => (
  <div className="flex flex-col gap-6 p-4 sm:p-6">
    <PlatformHealthSection />
    <PipelineStatusSection />
    <DataStatusSection />
  </div>
);

export default EtlDashboardTab;
